let tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
let webinarPlayer;

let toggleCardAnimation;

$(window).on('load', () => {
  const pathname = window.location.pathname;
  const webinarCover = $('.webinar-cover-placer');
  const webinarVideoCover = $('.webinar-cover-image');
  const webinarPlayIcon = $('.webinar-cover-play-icon');
  const webinarCardOverflow = $('.webinar-cover-card-overflow');
  const webinarCardParent = $('.webinar-cover-card-parent');
  const webinarPhotosParent = $('.webinar-cover-photos-parent');
  const webinarCardLine = webinarCardParent.find('.descriptor-line');
  const webinarCardtitleWrapper = webinarCardParent.find('.webinar-cover-card-title-wrapper');

  const setWebinarCard = () => {
    const webinaPersonPhotos = $('.webinar-cover-multiply-photo');
    const personPhotosCount = webinaPersonPhotos.length;
    const photoWidth = pxToVw(webinaPersonPhotos.eq(0).outerWidth());
    const photoHeight = pxToVw(webinaPersonPhotos.eq(0).outerWidth());
    const photoOffset = isDesktop() ? 2.563 : isTablet() ? 3.776 : 6.389;
    if (personPhotosCount != 0) {
      webinarPhotosParent.width(
        `${photoWidth * personPhotosCount - (photoWidth - photoOffset) * (personPhotosCount - 1)}vw`
      );
      webinarPhotosParent.height(`${photoHeight}vw`);
      webinaPersonPhotos.each(function (index) {
        $(this).css({
          left: `${photoOffset * index}vw`,
          'z-index': `${personPhotosCount * 100 - index}`,
        });
      });
    }
    const closedWidth = pxToVw(webinarPhotosParent.width()) + 2.5;
    const closedHeight = pxToVw(webinarPhotosParent.height()) + 2.5;
    if (!isDesktop()) {
      webinarCardtitleWrapper.prepend(webinarPhotosParent);
    }
  };
  setWebinarCard();

  $(window).on('deviceChange', function () {
    setWebinarCard();
    if (!isDesktop()) {
      gsap.set(webinarCardOverflow, {
        clearProps: 'all',
      });
    }
  });

  toggleCardAnimation = (direction, isSet = false) => {
    const closedWidth = pxToVw(webinarPhotosParent.width()) + 2.5;
    const closedHeight = pxToVw(webinarPhotosParent.height()) + 2.5;

    gsap.to(webinarCardOverflow, {
      width: direction ? '37.188vw' : `${closedWidth}vw`,
      height: direction ? '30.625vw' : `${closedHeight}vw`,
      duration: isSet ? 0 : 1,
      ease: 'pageInEasing',
      overwrite: 'auto',
    });
    gsap.to(webinarCardParent, {
      y: direction ? 0 : '5vw',
      duration: isSet ? 0 : 1,
      ease: 'pageInEasing',
      overwrite: 'auto',
    });
    gsap.to(webinarCardParent, {
      opacity: direction ? 1 : 0,
      duration: isSet ? 0 : 0.83,
      ease: 'opacityInEasing',
      overwrite: 'auto',
      delay: direction ? 0.16 : 0,
    });
    gsap.to(webinarCardLine, {
      width: direction ? '100%' : 0,
      duration: isSet ? 0 : 1,
      ease: 'opacityInEasing',
      overwrite: 'auto',
    });
  };

  const setYoutubePlayer = () => {
    const playerParent = webinarCover.find('#player');
    if (playerParent.length == 0) return;
    const webinarVideoLink = playerParent.attr('data-url').replace('https://www.youtube.com/watch?v=', '');
    webinarPlayer = new YT.Player('player', {
      height: '360',
      width: '640',
      videoId: webinarVideoLink,
      playerVars: {
        autoplay: 0,
        rel: 0,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  };

  function onPlayerReady(event) {
    webinarVideoCover.on('click', function () {
      $(this).fadeOut(300);
      webinarPlayIcon.fadeOut(300);
      webinarPlayer.playVideo();
    });
    webinarCover.on('click', function(){
      const playerState = webinarPlayer.getPlayerState();
      if(playerState == 1){
        webinarPlayer.pauseVideo();
      } else if(playerState == 2){
        webinarPlayer.playVideo();
      }
      
    })
  }

  function onPlayerStateChange(event) {
    switch (event.data) {
      case YT.PlayerState.PLAYING:
        isDesktop() ? toggleCardAnimation(false) : false;
        break;

      case YT.PlayerState.PAUSED:
        isDesktop() ? toggleCardAnimation(true) : false;
        break;

      case YT.PlayerState.ENDED:
        break;
    }
  }


  setYoutubePlayer();
});
